import Vue from 'vue'

export const SHRIFT_SET_CONNECTION = 'SHRIFT_SET_CONNECTION'
export const SHRIFT_SET_STATUS = 'SHRIFT_SET_STATUS'
export const SHRIFT_ADD_PARTICIPANT = 'SHRIFT_ADD_PARTICIPANT'
export const SHRIFT_REMOVE_PARTICIPANT = 'SHRIFT_REMOVE_PARTICIPANT'
export const SHRIFT_CLEAR_PARTICIPANTS = 'SHRIFT_CLEAR_PARTICIPANTS'
export const SHRIFT_SET_VIDEO_DEVICE = 'SHRIFT_SET_VIDEO_DEVICE'
export const SHRIFT_SET_AUDIO_DEVICE = 'SHRIFT_SET_AUDIO_DEVICE'
export const SHRIFT_SET_PARTICIPANT_STATUS = 'SHRIFT_SET_PARTICIPANT_STATUS'
export const SHRIFT_SET_ALL_PARTICIPANTS_OFFLINE = 'SHRIFT_SET_ALL_PARTICIPANTS_OFFLINE'
export const SHRIFT_SET_MESSAGES = 'SHRIFT_SET_MESSAGES'
export const SHRIFT_ADD_MESSAGE = 'SHRIFT_ADD_MESSAGE'
export const SHRIFT_CLEAR_MESSAGES = 'SHRIFT_CLEAR_MESSAGES'
export const SHRIFT_SET_PRIEST_ON_SHRIFT = 'SHRIFT_SET_PRIEST_ON_SHRIFT'

export default {
  [SHRIFT_SET_CONNECTION] (state, connection) {
    Vue.set(state, 'connection', connection)
  },
  [SHRIFT_SET_PRIEST_ON_SHRIFT] (state, busy) {
    Vue.set(state, 'isPriestOnShrift', busy)
  },
  [SHRIFT_SET_STATUS] (state, status) {
    Vue.set(state, 'connected', !!status)
  },
  [SHRIFT_SET_VIDEO_DEVICE] (state, device) {
    Vue.set(state.devices, 'video', device)
  },
  [SHRIFT_SET_AUDIO_DEVICE] (state, device) {
    Vue.set(state.devices, 'audio', device)
  },
  [SHRIFT_ADD_PARTICIPANT] (state, participant) {
    Vue.set(state.participants, participant.id, participant)
  },
  [SHRIFT_REMOVE_PARTICIPANT] (state, participant) {
    Vue.delete(state.participants, participant.id)
  },
  [SHRIFT_CLEAR_PARTICIPANTS] (state) {
    Vue.set(state, 'participants', {})
  },
  [SHRIFT_SET_PARTICIPANT_STATUS] (state, { participant, online }) {
    if (!state.participants[participant.id]) {
      return
    }
    Vue.set(state.participants[participant.id], 'online', online)
  },
  [SHRIFT_SET_ALL_PARTICIPANTS_OFFLINE] (state) {
    Object.values(state.participants).forEach(participant => {
      Vue.set(state.participants[participant.id], 'online', false)
    })
  },
  [SHRIFT_SET_MESSAGES] (state, messages) {
    Vue.set(state, 'messages', messages)
  },
  [SHRIFT_ADD_MESSAGE] (state, message) {
    state.messages.push(message)
  },
  [SHRIFT_CLEAR_MESSAGES] (state) {
    Vue.set(state, 'messages', [])
  }
}
